import de from '~/i18n/locales/de.json'
import en from '~/i18n/locales/en.json'
import es from '~/i18n/locales/es.json'
import fr from '~/i18n/locales/fr.json'
import it from '~/i18n/locales/it.json'
import ja from '~/i18n/locales/ja.json'
import ko from '~/i18n/locales/ko.json'
import nl from '~/i18n/locales/nl.json'
import pt from '~/i18n/locales/pt.json'
import sv from '~/i18n/locales/sv.json'

export default {
  fallbackLocale: 'en',
  legacy: false,
  locale: 'en',
  messages: {
    de,
    en,
    es,
    fr,
    it,
    pt,
    nl,
    sv,
    ja,
    ko,
  },
}
